var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:'button--' + _vm.color},[_vm._t("default"),(_vm.disable)?_c('div',{staticClass:"button__overlay"},[_c('span',{staticClass:"button__overlay__text"},[_vm._v(_vm._s(_vm.disabledMessage))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }